import React, { useCallback, useEffect, useState } from 'react';
import { intakeApi, STATUS_LABELS } from '../utils/jobIntake';

// Company admin: HM-created jobs and their hiring manager, with "reassign to another HM" (audit-logged).
// Renders nothing unless HM-led job creation is enabled and there are jobs.
function AdminHmJobs() {
  const [data, setData] = useState(null);
  const [choice, setChoice] = useState({});
  const [msg, setMsg] = useState('');

  const load = useCallback(() => intakeApi('/company').then(setData).catch(() => setData(null)), []);
  useEffect(() => { load(); }, [load]);
  if (!data || !data.jobs.length) return null;

  const reassign = async (job) => {
    setMsg('');
    try {
      const res = await intakeApi(`/${job.id}/reassign-hm`, { method: 'POST', body: { hm_user_id: Number(choice[job.id]) } });
      setMsg(`Reassigned to ${res.hm_name}.`);
      await load();
    } catch (e) { setMsg(e.message); }
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5" data-testid="admin-hm-jobs">
      <h3 className="text-lg font-black text-gray-900">Hiring manager jobs</h3>
      <p className="text-xs text-gray-500 mb-3">Jobs created by hiring managers. Only the assigned hiring manager can approve.</p>
      {msg && <p className="text-sm text-gray-700 mb-2">{msg}</p>}
      {data.jobs.map((job) => (
        <div key={job.id} className="flex flex-wrap items-center gap-2 py-2 border-b border-gray-100" data-testid="admin-hm-job">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-900 truncate">{job.job_title || 'Untitled job'}</p>
            <p className="text-xs text-gray-500">{job.hm_name || '—'} · {STATUS_LABELS[job.status] || job.status}</p>
          </div>
          <select aria-label={`New hiring manager for ${job.id}`} value={choice[job.id] || ''}
            onChange={(e) => setChoice({ ...choice, [job.id]: e.target.value })}
            className="px-2 py-1.5 border border-gray-200 rounded-lg text-sm">
            <option value="">Reassign to…</option>
            {data.hiring_managers.filter((h) => h.id !== job.hm_user_id).map((h) => <option key={h.id} value={h.id}>{h.full_name}</option>)}
          </select>
          <button disabled={!choice[job.id]} onClick={() => reassign(job)}
            className="px-3 py-1.5 rounded-lg border border-brand-blue text-brand-blue text-xs font-bold disabled:opacity-40">Reassign</button>
        </div>
      ))}
    </div>
  );
}

export default AdminHmJobs;
